import React from 'react';
import {colors} from '../theme';

interface PageTitleProps {
  title: string;
}

const PageTitle: React.FC<PageTitleProps> = ({title}) => {
  return (
    <h2 style={{fontSize: 22, fontWeight: 600, color: colors.textPrimary, marginBottom: 16, marginTop: 0}}>
      {title}
    </h2>
  );
};

export default PageTitle;
